import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=7173cbd5&scoped=true&"
import script from "./noticeDetails.vue?vue&type=script&lang=js&"
export * from "./noticeDetails.vue?vue&type=script&lang=js&"
import style0 from "./noticeDetails.vue?vue&type=style&index=0&id=7173cbd5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7173cbd5",
  null
  
)

export default component.exports